import React from 'react';

import { STATUS_OK } from 'apps/auth/constants/Constants';
import { CASH_PICKUP, INTERAC } from 'apps/auth/constants/GaConstants';

import GaCheckButtons from './GtHistory/GaCheckButtons';
import GaCheckHeader from './GtHistory/GaCheckHeader';
import GaDateFeeRateUnit from './GtHistory/GaDateFeeRateUnit';
import GaPaymentNumber from './GtHistory/GaPaymentNumber';
import GaRecipientDetails from './GtHistory/GaRecipientDetails';

const ActivityGlobalTransferDetails = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { stsId } = props.options;
    const isInProgress = stsId >= 10 && stsId < STATUS_OK;
    const specialCases = (mobileInfo.icon === INTERAC || mobileInfo.icon === CASH_PICKUP) && isInProgress && !mobileInfo.extraFields.transactionCode;

    return (
        <>
            <GaCheckHeader item={item} options={props.options} />
            {(isInProgress || !specialCases) && <GaCheckButtons pocketId={props.pocketId} item={item} options={props.options} />}
            <GaDateFeeRateUnit item={item} options={props.options} />
            <GaRecipientDetails item={item} options={props.options} />
            <GaPaymentNumber item={item} options={props.options} />
        </>
    );
};

export default ActivityGlobalTransferDetails;
